import { FunctionComponent } from 'react'
import { Typography } from '@black-bear-energy/rucksack'

/**
 * Inline bold text for emphasizing a word or phrase within a body Typography.
 * Renders an inline `<span>` and uses the theme's bold font weight.
 */
export const BoldText: FunctionComponent<BoldTextProps> = ({ children }) => (
  <Typography component="span" sx={{ fontWeight: 'bold' }}>
    {children}
  </Typography>
)

interface BoldTextProps {
  children: React.ReactNode
}
